<div [class]="colourClass">
  <ng-content></ng-content>
</div>
